export default __webpack_public_path__ + "static/g501-6300b8adaeb36ee68b497b8b9378da6b.jpeg";